
import React from 'react';
import { Button } from '../../../components/base/Button';

export const HeroSection: React.FC = () => {
  const handleWhatsApp = () => {
    window.open('https://wa.me/554888397243?text=Olá! Gostaria de agendar um orçamento para os serviços da Aura Estética Automotiva.', '_blank');
  };

  const scrollToServices = () => {
    const element = document.getElementById('servicos');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section 
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20 md:pt-0"
    >
      {/* Background Image - Otimizada para mobile */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(13, 13, 13, 0.7), rgba(13, 13, 13, 0.5)), url('https://static.readdy.ai/image/23e6e82711d555609e11a3dec8506ccb/91a5ac64e039feea723336f8574355cf.jpeg')`
        }}
      />
      
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="max-w-4xl mx-auto">
          {/* Main Title - Responsivo */}
          <h1 className="text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-montserrat font-bold text-white mb-4 leading-tight tracking-wide">
            <span className="text-[#C8A45D]">ESTÉTICA AUTOMOTIVA</span>
            <span className="block mt-2">
              PREMIUM
            </span>
          </h1>

          {/* Subtitle - Mais específico e responsivo */}
          <p className="text-sm sm:text-base md:text-xl text-gray-300 mb-6 font-open-sans max-w-2xl mx-auto leading-relaxed px-4">
            PPF • Vitrificação • Película • Polimentos • Higienização • Lavação Detalhada
          </p>

          {/* Benefícios rápidos - Responsivo */}
          <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-6 md:mb-8 text-xs sm:text-sm md:text-base px-4">
            <span className="bg-[#C8A45D]/20 text-[#C8A45D] px-2 md:px-3 py-1 rounded-full border border-[#C8A45D]/30 whitespace-nowrap">
              ✓ Seu carro sempre novo
            </span>
            <span className="bg-[#C8A45D]/20 text-[#C8A45D] px-2 md:px-3 py-1 rounded-full border border-[#C8A45D]/30 whitespace-nowrap">
              ✓ Brilho duradouro
            </span>
            <span className="bg-[#C8A45D]/20 text-[#C8A45D] px-2 md:px-3 py-1 rounded-full border border-[#C8A45D]/30 whitespace-nowrap">
              ✓ Valorização do veículo
            </span>
          </div>

          {/* CTA Principal - Otimizado para mobile */}
          <div className="mb-4 md:mb-6 px-4">
            <Button
              onClick={handleWhatsApp}
              variant="primary"
              size="lg"
              className="text-sm sm:text-base md:text-lg px-6 md:px-8 py-3 md:py-4 w-full sm:w-auto max-w-sm mx-auto"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              ENTRAR EM CONTATO
            </Button>
          </div>

          {/* CTA Secundário */}
          <button 
            onClick={scrollToServices}
            className="text-[#C8A45D] underline text-xs sm:text-sm hover:text-white transition-colors"
          >
            Ver todos os serviços ↓
          </button>

          {/* Micro Text */}
          <p className="text-xs text-gray-400 font-open-sans mt-4 px-4">
            Atendimento em Florianópolis • <strong className="text-[#C8A45D]">Garantia Aura</strong>
          </p>
        </div>
      </div>
    </section>
  );
};